/*
 * winerd-configurator.js — Configurador Winerd de 5 pasos (Task #119, fase 3/7).
 *
 * Sustituye al quizz (quizz-optimized.liquid + quizz.js) por el flujo de la
 * maqueta task-115/mockup.html (vista "Configurador"). Clase vanilla al estilo
 * de assets/quizz.js — sin dependencias, sin bundle (sobrevive a
 * recompilaciones del tema por Maestrooo).
 *
 * Fase 3: esqueleto multistep + pasos 1 (modo) y 2 (gusto).
 * Fase 4: paso 3 — catálogo real + buscador + simulador.
 * Fase 5: paso 4 — resumen editable botella por botella (Cambiar / Dejar al
 *   sommelier / Quitar) + picker inline con buscador y tabs propios + tarjeta
 *   de resumen con subtotal estimado y barra de envío gratis.
 * Fase 6: paso 5 — pantalla de renovación presentacional (próxima entrega con
 *   fecha calculada por frecuencia, timeline de renovación) + wiring del
 *   checkout por modo:
 *     · somm  → una línea winred (tinto/blanco según el paso 2) por el total
 *       de la caja, con selling_plan de Recurring Go según la frecuencia + nota.
 *     · mixed → cada etiqueta elegida como línea de producto (selling_plan
 *       resuelto vía /products/<handle>.js, con fallback a compra única mientras
 *       la migración #116 no publique los selling plans del catálogo general) +
 *       una línea winred por las botellas que completa el sommelier.
 *     · pick  → solo las etiquetas elegidas (mismo resolución/fallback).
 *   Los IDs winred / planes RGo viven centralizados en la constante WINRED de
 *   este archivo (espejo de assets/quizz.js; migrar con la #116).
 *
 * El markup lo pone sections/winerd-configurator.liquid; el CSS vive en
 * assets/winerd.css (bloque "FASE 3"). Todo bajo .winerd-scope — ver
 * docs/winerd-vista.md.
 *
 * Deep-links (desde la landing o una URL compartida):
 *   ?modo=somm|mixed|pick   selecciona el modo del paso 1
 *   ?paso=1..5  ó  #paso-3   abre directamente ese paso
 */
(function () {
  "use strict";

  /* Cepas: mismas listas que quizz-optimized.liquid / la maqueta #115. */
  var GRAPES = {
    tinto: {
      basic: [
        "Zinfandel",
        "Malbec",
        "Cabernet Sauvignon",
        "Bordeaux Blends",
        "Chianti",
        "Merlot",
        "Pinot Noir"
      ],
      expert: [
        "Syrah / Shiraz",
        "Napa Cabernet",
        "Rioja",
        "Rhône Blends",
        "California Red Blends",
        "Grenache",
        "California Pinot Noir",
        "Burgundy"
      ]
    },
    blanco: {
      basic: [
        "Chardonnay",
        "Sauvignon Blanc",
        "Pinot Grigio",
        "Riesling",
        "Moscato"
      ],
      expert: [
        "Viognier",
        "Chenin Blanc",
        "Crisp Chardonnay",
        "Grüner Veltliner",
        "Albariño"
      ]
    }
  };

  var MODE_LABEL = {
    somm: "Lo elige mi sommelier",
    mixed: "Caja mixta",
    pick: "Yo elijo mis etiquetas"
  };

  var GRAPE_VALUES = ["like", "open", "no"];
  var STEP_COUNT = 5;

  /*
   * Winred: única fuente de los IDs de suscripción para el configurador nuevo.
   * Es un espejo de assets/quizz.js (variantes por precio de botella). Los
   * `plans` son del SellingPlanGroup nativo "Una forma diferente de pedir
   * vino" (grupo 1c907f72e3669152594c4279291d594baa2338fe) — Recurring Go se
   * retira (decisión del Maestro, 2026-09-11); assets/quizz.js (el
   * cuestionario legacy, todavía en producción) sigue en Recurring Go a
   * propósito, se migra aparte cuando se retire ese flujo.
   */
  var WINRED = {
    tinto: {
      "765": "44128798081252",
      "850": "44128798114020",
      "935": "44128798146788",
      "1020": "44128798179556",
      "1300": "44128798212324"
    },
    blanco: {
      "765": "44128800309476",
      "850": "44128800342244",
      "935": "44128800375012",
      "1020": "44128800407780",
      "1300": "44128800440548"
    },
    /* No equidistantes (el último salto es de 280): el slider del sommelier
       corre por índice, no en pesos. */
    points: [765, 850, 935, 1020, 1300],
    /* selling_plan nativo (Shopify Subscriptions) por meses entre entregas */
    plans: { 1: "4472864996", 2: "4472897764", 3: "4472930532" }
  };

  var FREQ_MONTHS = {
    "Cada 1 mes": 1,
    "Cada 2 meses": 2,
    "Cada 3 meses": 3
  };

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function clampStep(n) {
    if (isNaN(n)) return 1;
    return Math.min(STEP_COUNT, Math.max(1, n));
  }

  function clampNum(n, lo, hi, fallback) {
    if (isNaN(n)) return fallback;
    return Math.min(hi, Math.max(lo, n));
  }

  /* ---------- helpers del paso 3 (catálogo) ---------- */

  function money(value) {
    var n = Number(value) || 0;
    try {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        maximumFractionDigits: 0
      }).format(n);
    } catch (e) {
      return "$" + Math.round(n);
    }
  }

  function shopRoot() {
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
    } catch (e) {}
    return "/";
  }

  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function productPrice(product) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var prices = variants
      .map(function (v) { return parseFloat(v.price); })
      .filter(function (v) { return isFinite(v) && v > 0; });
    return prices.length ? Math.min.apply(null, prices) : 0;
  }

  function productAvailable(product) {
    if (!Array.isArray(product.variants) || !product.variants.length) return true;
    return product.variants.some(function (v) { return v.available !== false; });
  }

  function productImage(product) {
    if (Array.isArray(product.images) && product.images.length) {
      var first = product.images[0];
      return typeof first === "string" ? first : first.src || "";
    }
    if (product.featured_image) {
      return typeof product.featured_image === "string"
        ? product.featured_image
        : product.featured_image.src || "";
    }
    return "";
  }

  function productHaystack(product) {
    var tags = Array.isArray(product.tags) ? product.tags.join(" ") : product.tags;
    return [product.title, product.product_type, product.vendor, tags]
      .join(" ")
      .toLowerCase();
  }

  /* Los tags del catálogo real vienen con prefijos consistentes del
     Maestro: "País_México", "Tipo de Vino_Vino Tinto", etc. */
  function productTagValue(product, prefix) {
    var tags = Array.isArray(product.tags) ? product.tags : [];
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf(prefix) === 0) return tags[i].slice(prefix.length);
    }
    return "";
  }

  function productCountry(product) {
    return productTagValue(product, "País_");
  }

  /* Decodifica el body_html a texto plano usando el parser del navegador
     (nunca se vuelve a insertar como HTML — solo se lee .textContent). */
  function stripHtml(html) {
    if (!html) return "";
    var div = document.createElement("div");
    div.innerHTML = html;
    return (div.textContent || "").replace(/\s+/g, " ").trim();
  }

  function truncate(text, max) {
    if (text.length <= max) return text;
    return text.slice(0, max).replace(/\s+\S*$/, "") + "…";
  }

  /* Silueta de botella compartida por los 4 usos del configurador:
     tinto/blanco (color del vino) y tuya/sommelier (quién la elige). El
     mismo path en los 4, solo cambia relleno/trazo — "sommelier" usa
     trazo punteado, el mismo lenguaje visual que .recap-row--somm. */
  var BOTTLE_PATH =
    '<rect x="9" y="2" width="6" height="4" rx="1"></rect>' +
    '<path d="M10 6V11C7.5 13 6 15.8 6 19V34A2 2 0 0 0 8 36H16A2 2 0 0 0 18 34V19C18 15.8 16.5 13 14 11V6Z"></path>';

  function bottleIcon(kind, size) {
    size = size || 22;
    var height = Math.round((size * 40) / 24);
    var fill = "none";
    var stroke = "none";
    var dash = "";
    if (kind === "tinto") {
      fill = "var(--wine)";
    } else if (kind === "blanco") {
      fill = "var(--cream)";
      stroke = "var(--muted)";
    } else if (kind === "tuya") {
      fill = "var(--navy)";
    } else {
      stroke = "var(--wine)";
      dash = ' stroke-dasharray="3 2"';
    }
    return (
      '<svg class="wine-bottle-icon" viewBox="0 0 24 40" width="' +
      size +
      '" height="' +
      height +
      '" aria-hidden="true" focusable="false" fill="' +
      fill +
      '" stroke="' +
      stroke +
      '" stroke-width="1.6"' +
      dash +
      ">" +
      BOTTLE_PATH +
      "</svg>"
    );
  }

  var TYPE_RE = {
    tinto: /(tinto|red wine|cabernet|merlot|malbec|syrah|shiraz|tempranillo|nebbiolo|pinot noir|primitivo|garnacha|nero d.avola|bonarda|monastrell|sangiovese|carmen[eè]re)/i,
    blanco: /(blanco|white wine|riesling|chardonnay|sauvignon|verdejo|albari|pinot gris|pinot grigio|chenin|viognier|gew[uü]rz|moscato|godello|grillo)/i,
    espumoso: /(espumoso|sparkling|prosecco|champagne|\bcava\b|spumante|pet.?nat|cr[eé]mant|lambrusco|franciacorta|blanc de blancs)/i
  };

  function productMatchesType(product, type) {
    if (!type || type === "todos") return true;
    return TYPE_RE[type] ? TYPE_RE[type].test(productHaystack(product)) : true;
  }

  var TAB_LABEL = { todos: "Vinos", tinto: "Tinto", blanco: "Blanco", espumoso: "Espumoso" };

  function emptyState(title, text) {
    return (
      '<div class="catalog-empty"><strong>' +
      esc(title) +
      "</strong><p>" +
      esc(text) +
      "</p></div>"
    );
  }

  class WinerdConfigurator {
    constructor(root) {
      this.root = root;
      this.panels = toArray(root.querySelectorAll("[data-winerd-panel]"));
      this.steps = toArray(root.querySelectorAll("[data-winerd-step]"));
      this.qty = parseInt(root.dataset.bottles, 10) || 6;

      this.state = {
        mode: "somm",
        mixYou: Math.min(2, this.qty),
        sommTintoCount: this.qty,
        adventure: "mismos",
        level: "novato",
        aboutMe: "",
        grapes: {},
        occasion: "Para relajarme en la semana",
        frequency: "Cada 2 meses",
        catalogType: "todos",
        catalogCountry: "todos",
        sortBy: "price_asc",
        search: "",
        budgetMin: 0,
        budgetMax: 0,
        sommBudgetTarget: 0,
        picks: [],
        picker: { search: "", type: "todos" }
      };

      this.catalog = [];
      this.catalogLoaded = false;
      this.pickerIndex = null;
      this.budgetCatalogTimer = null;

      var freeShip = parseInt(root.dataset.winerdFreeShip, 10);
      this.freeShip = isNaN(freeShip) || freeShip < 0 ? 0 : freeShip;

      this.booting = true;
      this.init();
      this.booting = false;
    }

    init() {
      this.bindNav();
      this.bindModeStep();
      this.bindMixSplit();
      this.bindGrapeMore();
      this.bindSommSplit();
      this.bindSommBudget();
      this.bindChoiceGroups();
      this.bindAboutMe();
      this.bindCatalogStep();
      this.bindRecapStep();
      this.bindRenewalStep();
      this.renderGrapes();

      var start = this.applyDeepLink();
      this.selectMode(this.state.mode);
      this.goPanel(start);

      this.loadCatalog();
    }

    /* ---------- navegación multistep ---------- */

    currentPanel() {
      var active = this.panels.filter(function (p) {
        return p.classList.contains("is-active");
      })[0];
      return active ? clampStep(parseInt(active.dataset.winerdPanel, 10)) : 1;
    }

    goPanel(n) {
      var step = clampStep(n);

      this.panels.forEach(function (panel) {
        panel.classList.toggle(
          "is-active",
          parseInt(panel.dataset.winerdPanel, 10) === step
        );
      });

      this.steps.forEach(function (item) {
        var value = parseInt(item.dataset.winerdStep, 10);
        item.classList.toggle("is-active", value === step);
        item.classList.toggle("is-done", value < step);
        if (value === step) {
          item.setAttribute("aria-current", "step");
        } else {
          item.removeAttribute("aria-current");
        }
      });

      if (step === 3) this.refreshCatalogStep();
      if (step === 4) this.renderRecap();
      if (step === 5) this.renderRenewal();

      if (!this.booting) {
        try {
          history.replaceState(null, "", "#paso-" + step);
        } catch (e) {}
        this.root.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    bindNav() {
      var self = this;

      toArray(this.root.querySelectorAll("[data-winerd-next]")).forEach(function (btn) {
        btn.addEventListener("click", function () {
          self.goPanel(self.currentPanel() + 1);
        });
      });

      toArray(this.root.querySelectorAll("[data-winerd-prev]")).forEach(function (btn) {
        btn.addEventListener("click", function () {
          self.goPanel(self.currentPanel() - 1);
        });
      });

      this.steps.forEach(function (item) {
        item.addEventListener("click", function () {
          self.goPanel(parseInt(item.dataset.winerdStep, 10));
        });
      });
    }

    applyDeepLink() {
      var mode = null;
      var step = null;

      try {
        var params = new URLSearchParams(window.location.search);
        mode = params.get("modo");
        if (params.get("paso")) step = parseInt(params.get("paso"), 10);
      } catch (e) {}

      var hash = window.location.hash || "";
      var hashStep = hash.match(/^#paso-(\d)$/);
      var hashMode = hash.match(/^#modo-(somm|mixed|pick)$/);
      if (hashStep) step = parseInt(hashStep[1], 10);
      if (hashMode) mode = hashMode[1];

      if (mode && MODE_LABEL[mode]) this.state.mode = mode;

      return step ? clampStep(step) : 1;
    }

    /* ---------- paso 1 · modo ---------- */

    bindModeStep() {
      var self = this;
      toArray(this.root.querySelectorAll("[data-winerd-mode]")).forEach(function (card) {
        card.addEventListener("click", function () {
          self.selectMode(card.dataset.winerdMode);
        });
      });
    }

    selectMode(mode) {
      if (!MODE_LABEL[mode]) mode = "somm";
      this.state.mode = mode;

      toArray(this.root.querySelectorAll("[data-winerd-mode]")).forEach(function (card) {
        var active = card.dataset.winerdMode === mode;
        card.classList.toggle("is-active", active);
        card.setAttribute("aria-pressed", active ? "true" : "false");
      });

      var you =
        mode === "somm" ? 0 : mode === "pick" ? this.qty : Math.min(this.state.mixYou, this.qty);
      var somm = this.qty - you;

      var readout = this.root.querySelector("[data-winerd-internal-readout]");
      if (readout) {
        readout.textContent =
          "Botellas que eliges tú = " + you + " · el sommelier completa " + somm;
      }

      toArray(this.root.querySelectorAll("[data-winerd-mode-label]")).forEach(function (el) {
        el.textContent = MODE_LABEL[mode];
      });

      this.updateMixSplit();
      this.updateSommSplit();
      this.refreshCatalogStep();
    }

    /* ---------- paso 1 · reparto tú/sommelier en modo mixto ---------- */

    bindMixSplit() {
      var self = this;
      var dec = this.root.querySelector("[data-winerd-mix-dec]");
      var inc = this.root.querySelector("[data-winerd-mix-inc]");

      if (dec) {
        dec.addEventListener("click", function () {
          self.setMixYou(self.state.mixYou - 1);
        });
      }
      if (inc) {
        inc.addEventListener("click", function () {
          self.setMixYou(self.state.mixYou + 1);
        });
      }
    }

    setMixYou(value) {
      this.state.mixYou = clampNum(value, 0, this.qty, this.state.mixYou);
      this.selectMode(this.state.mode);
    }

    updateMixSplit() {
      var wrap = this.root.querySelector("[data-winerd-mix-split]");
      if (!wrap) return;

      var isMixed = this.state.mode === "mixed";
      wrap.hidden = !isMixed;
      if (!isMixed) return;

      var you = Math.min(this.state.mixYou, this.qty);
      var somm = this.qty - you;

      var youEl = this.root.querySelector("[data-winerd-mix-you]");
      var totalEl = this.root.querySelector("[data-winerd-mix-total]");
      var sommEl = this.root.querySelector("[data-winerd-mix-somm]");
      var dec = this.root.querySelector("[data-winerd-mix-dec]");
      var inc = this.root.querySelector("[data-winerd-mix-inc]");

      if (youEl) youEl.textContent = you;
      if (totalEl) totalEl.textContent = this.qty;
      if (sommEl) sommEl.textContent = somm;
      if (dec) dec.disabled = you <= 0;
      if (inc) inc.disabled = you >= this.qty;

      this.renderBottleRow("[data-winerd-mix-bottles]", [
        { kind: "tuya", count: you },
        { kind: "sommelier", count: somm }
      ]);
    }

    /* Fila de botellitas que crece/encoge con el conteo real — usada tanto
       por el reparto tú/sommelier (paso 1) como por el tinto/blanco
       (paso 2). */
    renderBottleRow(selector, entries) {
      var el = this.root.querySelector(selector);
      if (!el) return;
      var html = "";
      entries.forEach(function (entry) {
        for (var i = 0; i < entry.count; i++) html += bottleIcon(entry.kind, 16);
      });
      el.innerHTML = html;
    }

    /* ---------- reparto tinto/blanco de las botellas del sommelier ---------- */

    sommCount() {
      if (this.state.mode === "pick") return 0;
      if (this.state.mode === "somm") return this.qty;
      return Math.max(0, this.qty - Math.min(this.state.mixYou, this.qty));
    }

    bindSommSplit() {
      var self = this;
      var dec = this.root.querySelector("[data-winerd-somm-tinto-dec]");
      var inc = this.root.querySelector("[data-winerd-somm-tinto-inc]");

      if (dec) {
        dec.addEventListener("click", function () {
          self.setSommTinto(self.state.sommTintoCount - 1);
        });
      }
      if (inc) {
        inc.addEventListener("click", function () {
          self.setSommTinto(self.state.sommTintoCount + 1);
        });
      }
    }

    setSommTinto(value) {
      var count = this.sommCount();
      this.state.sommTintoCount = clampNum(value, 0, count, this.state.sommTintoCount);
      this.updateSommSplit();
    }

    updateSommSplit() {
      var count = this.sommCount();

      var budgetWrap = this.root.querySelector("[data-winerd-somm-budget-wrap]");
      if (budgetWrap) budgetWrap.hidden = count <= 0;

      var wrap = this.root.querySelector("[data-winerd-somm-split]");
      if (!wrap) return;
      wrap.hidden = count <= 0;
      if (count <= 0) return;

      this.state.sommTintoCount = clampNum(this.state.sommTintoCount, 0, count, count);

      var tinto = this.state.sommTintoCount;
      var blanco = count - tinto;

      var tintoEl = this.root.querySelector("[data-winerd-somm-tinto]");
      var blancoEl = this.root.querySelector("[data-winerd-somm-blanco]");
      var totalEl = this.root.querySelector("[data-winerd-somm-total]");
      var dec = this.root.querySelector("[data-winerd-somm-tinto-dec]");
      var inc = this.root.querySelector("[data-winerd-somm-tinto-inc]");

      if (tintoEl) tintoEl.textContent = tinto;
      if (blancoEl) blancoEl.textContent = blanco;
      if (totalEl) totalEl.textContent = count;
      if (dec) dec.disabled = tinto <= 0;
      if (inc) inc.disabled = tinto >= count;

      this.renderBottleRow("[data-winerd-somm-bottles]", [
        { kind: "tinto", count: tinto },
        { kind: "blanco", count: blanco }
      ]);
    }

    /* ---------- paso 2 · gusto ---------- */

    bindGrapeMore() {
      var moreBtn = this.root.querySelector("[data-winerd-grape-more]");
      var expert = this.root.querySelector("[data-winerd-grape-expert]");
      if (moreBtn && expert) {
        moreBtn.addEventListener("click", function () {
          var willOpen = expert.hasAttribute("hidden");
          if (willOpen) {
            expert.removeAttribute("hidden");
            moreBtn.textContent = "Ver menos cepas ↑";
          } else {
            expert.setAttribute("hidden", "");
            moreBtn.textContent = "Ver más cepas (para expertos) ↓";
          }
          moreBtn.setAttribute("aria-expanded", willOpen ? "true" : "false");
        });
      }
    }

    grapeCardMarkup(name) {
      return (
        '<div class="grape" data-winerd-grape="' +
        name +
        '">' +
        '<span class="grape__name">' +
        name +
        "</span>" +
        '<div class="grape__opts" role="group" aria-label="' +
        name +
        '">' +
        '<button type="button" data-v="like">Me gusta</button>' +
        '<button type="button" data-v="open">Abierto a ello</button>' +
        '<button type="button" data-v="no">No me gusta</button>' +
        "</div></div>"
      );
    }

    renderGrapes() {
      var self = this;

      ["tinto", "blanco"].forEach(function (color) {
        var set = GRAPES[color];
        var basic = self.root.querySelector('[data-winerd-grape-basic="' + color + '"]');
        var expertGrid = self.root.querySelector('[data-winerd-grape-expert-grid="' + color + '"]');

        if (basic) {
          basic.innerHTML = set.basic
            .map(function (name) {
              return self.grapeCardMarkup(name);
            })
            .join("");
        }
        if (expertGrid) {
          expertGrid.innerHTML = set.expert
            .map(function (name) {
              return self.grapeCardMarkup(name);
            })
            .join("");
        }
      });

      toArray(this.root.querySelectorAll(".grape__opts button")).forEach(function (btn) {
        var card = btn.closest(".grape");
        var name = card.dataset.winerdGrape;
        var value = btn.dataset.v;

        if (self.state.grapes[name] === value) btn.classList.add("on");

        btn.addEventListener("click", function () {
          var wasOn = btn.classList.contains("on");
          toArray(card.querySelectorAll(".grape__opts button")).forEach(function (other) {
            other.classList.remove("on");
          });
          if (wasOn) {
            delete self.state.grapes[name];
          } else if (GRAPE_VALUES.indexOf(value) > -1) {
            btn.classList.add("on");
            self.state.grapes[name] = value;
          }
        });
      });
    }

    bindChoiceGroups() {
      var self = this;
      toArray(this.root.querySelectorAll("[data-winerd-group]")).forEach(function (group) {
        var key = group.dataset.winerdGroup;
        group.addEventListener("click", function (event) {
          var choice = event.target.closest("[data-val]");
          if (!choice || !group.contains(choice)) return;
          toArray(group.querySelectorAll("[data-val]")).forEach(function (btn) {
            btn.classList.toggle("is-active", btn === choice);
          });
          self.state[key] = choice.dataset.val;

          if (key === "quantity") {
            var n = parseInt(choice.dataset.val, 10);
            if (n > 0) self.qty = n;
            self.selectMode(self.state.mode);
          } else if (key === "occasion" || key === "frequency") {
            if (key === "frequency") {
              /* El selling_plan de cada etiqueta específica queda cacheado
                 en _resolvedLine (para no repetir el fetch al pagar) — pero
                 eso incluye QUÉ frecuencia se resolvió. Si el cliente cambia
                 la frecuencia después de elegir sus etiquetas, hay que
                 invalidar el caché o el checkout sigue mandando el plan
                 viejo (bug real: las etiquetas específicas se quedaban en
                 "cada 1 mes" aunque el sommelier sí cambiaba). Se re-resuelve
                 solo, en el próximo resolvePickLine (checkout). */
              self.state.picks.forEach(function (p) {
                delete p._resolvedLine;
              });
            }
            self.renderProfile();
          }
        });
      });
    }

    bindAboutMe() {
      var self = this;
      var el = this.root.querySelector("[data-winerd-about-me]");
      if (!el) return;
      el.addEventListener("input", function () {
        self.state.aboutMe = el.value;
      });
    }

    /* ---------- paso 3 · catálogo + simulador ---------- */

    selMax() {
      if (this.state.mode === "somm") return 0;
      if (this.state.mode === "pick") return this.qty;
      return Math.min(this.state.mixYou, this.qty);
    }

    bindCatalogStep() {
      var self = this;

      this.grid = this.root.querySelector("[data-winerd-catalog-grid]");
      this.slotsEl = this.root.querySelector("[data-winerd-slots]");
      if (!this.grid && !this.slotsEl) return;

      /* Buscador por nombre / uva / región */
      var search = this.root.querySelector("[data-winerd-search]");
      var clearBtn = this.root.querySelector("[data-winerd-search-clear]");
      if (search) {
        search.addEventListener("input", function () {
          self.state.search = search.value.trim();
          if (clearBtn) clearBtn.hidden = self.state.search === "";
          self.renderCatalog();
        });
      }
      if (search && clearBtn) {
        clearBtn.addEventListener("click", function () {
          search.value = "";
          self.state.search = "";
          clearBtn.hidden = true;
          search.focus();
          self.renderCatalog();
        });
      }

      /* Tabs por tipo */
      toArray(this.root.querySelectorAll("[data-winerd-type]")).forEach(function (tab) {
        tab.addEventListener("click", function () {
          self.state.catalogType = tab.dataset.winerdType || "todos";
          toArray(self.root.querySelectorAll("[data-winerd-type]")).forEach(function (other) {
            other.classList.toggle("is-active", other === tab);
          });
          self.renderCatalog();
        });
      });

      /* Tabs por país (cobertura real ~48% del catálogo, así que se dejan
         solo los países más comunes; el resto sigue encontrable por
         búsqueda). */
      toArray(this.root.querySelectorAll("[data-winerd-country]")).forEach(function (tab) {
        tab.addEventListener("click", function () {
          self.state.catalogCountry = tab.dataset.winerdCountry || "todos";
          toArray(self.root.querySelectorAll("[data-winerd-country]")).forEach(function (other) {
            other.classList.toggle("is-active", other === tab);
          });
          self.renderCatalog();
        });
      });

      var sortSelect = this.root.querySelector("[data-winerd-catalog-sort]");
      if (sortSelect) {
        sortSelect.value = this.state.sortBy;
        sortSelect.addEventListener("change", function () {
          self.state.sortBy = sortSelect.value;
          self.renderCatalog();
        });
      }

      this.bindDescToggle(this.grid);

      var refresh = this.root.querySelector("[data-winerd-catalog-refresh]");
      if (refresh) {
        refresh.addEventListener("click", function () {
          self.loadCatalog(true);
        });
      }

      /* Doble rango de presupuesto sincronizado */
      this.budgetMinInput = this.root.querySelector("[data-winerd-budget-min]");
      this.budgetMaxInput = this.root.querySelector("[data-winerd-budget-max]");

      var floor = parseInt(this.root.dataset.winerdBudgetFloor, 10);
      if (isNaN(floor)) floor = 100;
      var ceiling = parseInt(this.root.dataset.winerdBudgetCeiling, 10);
      if (isNaN(ceiling) || ceiling <= floor) ceiling = floor + 2900;
      this.budgetFloor = floor;
      this.budgetCeiling = ceiling;

      this.state.budgetMin = clampNum(parseInt(this.root.dataset.winerdBudgetMin, 10), floor, ceiling, floor);
      this.state.budgetMax = clampNum(parseInt(this.root.dataset.winerdBudgetMax, 10), floor, ceiling, ceiling);
      if (this.state.budgetMin >= this.state.budgetMax) {
        this.state.budgetMin = floor;
        this.state.budgetMax = ceiling;
      }

      [this.budgetMinInput, this.budgetMaxInput].forEach(function (input) {
        if (!input) return;
        input.min = floor;
        input.max = ceiling;
        input.step = 20;
      });
      if (this.budgetMinInput) this.budgetMinInput.value = this.state.budgetMin;
      if (this.budgetMaxInput) this.budgetMaxInput.value = this.state.budgetMax;

      var onBudget = function (which) {
        return function () {
          var lo = parseInt(self.budgetMinInput.value, 10);
          var hi = parseInt(self.budgetMaxInput.value, 10);
          if (which === "min" && lo > hi - 20) {
            lo = Math.max(floor, hi - 20);
            self.budgetMinInput.value = lo;
          }
          if (which === "max" && hi < lo + 20) {
            hi = Math.min(ceiling, lo + 20);
            self.budgetMaxInput.value = hi;
          }
          self.state.budgetMin = lo;
          self.state.budgetMax = hi;
          self.renderBudgetLabels();
          self.renderProfile();
          /* renderCatalog() reconstruye todo el grid y cambia su alto — llamarlo
             en cada tick del slider hacía saltar el scroll. El label de arriba
             (renderBudgetLabels) sigue en vivo; el grid se debounce a 150ms. */
          clearTimeout(self.budgetCatalogTimer);
          self.budgetCatalogTimer = setTimeout(function () {
            self.renderCatalog();
          }, 150);
        };
      };
      if (this.budgetMinInput) this.budgetMinInput.addEventListener("input", onBudget("min"));
      if (this.budgetMaxInput) this.budgetMaxInput.addEventListener("input", onBudget("max"));

      /* Agregar / quitar del catálogo y de los slots */
      if (this.grid) {
        this.grid.addEventListener("click", function (event) {
          var btn = event.target.closest("[data-winerd-add]");
          if (!btn || btn.disabled) return;
          self.togglePick(btn.dataset.winerdAdd);
        });
      }
      if (this.slotsEl) {
        this.slotsEl.addEventListener("click", function (event) {
          var rm = event.target.closest("[data-winerd-remove-pick]");
          if (!rm) return;
          self.togglePick(rm.dataset.winerdRemovePick, true);
        });
      }

      /* La cantidad por defecto viene del ajuste de la sección (this.qty) */
      var qGroup = this.root.querySelector('[data-winerd-group="quantity"]');
      if (qGroup) {
        toArray(qGroup.querySelectorAll("[data-val]")).forEach(function (btn) {
          btn.classList.toggle("is-active", parseInt(btn.dataset.val, 10) === self.qty);
        });
      }

      this.renderBudgetLabels();
    }

    /* ---------- paso 2 · presupuesto independiente del sommelier ---------- */

    /* A pedido de Enrique: no es un rango (min a max) — es UN precio
       específico de los 5 reales de WINRED. Un solo thumb, no dos. */
    bindSommBudget() {
      var self = this;
      this.sommBudgetInput = this.root.querySelector("[data-winerd-somm-budget]");

      /* El <input> corre por índice (0..400, 100 por punto real) y no en
         pesos: los 5 precios no son equidistantes y así los ticks sí lo
         son. step=1 deja el arrastre 100% fluido (sigue al mouse/dedo sin
         saltos) — el snap a un precio real se hace a mano en "commit",
         solo al soltar o al usar el teclado. */
      var points = WINRED.points;
      var SLOT = 100;
      var maxIndex = (points.length - 1) * SLOT;

      var toPrice = function (index) {
        return points[Math.round(clampNum(index, 0, maxIndex, 0) / SLOT)];
      };

      /* Precio "crudo" mientras se arrastra: interpola entre los dos
         puntos reales vecinos, para que la etiqueta sí se mueva. */
      var rawPrice = function (index) {
        var v = clampNum(index, 0, maxIndex, 0) / SLOT;
        var i = Math.min(Math.floor(v), points.length - 2);
        return Math.round(points[i] + (points[i + 1] - points[i]) * (v - i));
      };

      this.state.sommBudgetTarget = this.nearestPricePoint(
        parseInt(this.root.dataset.winerdSommBudgetValue, 10) || 935
      );
      var anchor = points.indexOf(this.state.sommBudgetTarget) * SLOT;

      if (this.sommBudgetInput) {
        this.sommBudgetInput.min = 0;
        this.sommBudgetInput.max = maxIndex;
        this.sommBudgetInput.step = 1;
        this.sommBudgetInput.value = anchor;
      }

      var band = this.root.querySelector("[data-winerd-somm-band]");

      var pct = function (index) {
        return (index / maxIndex) * 100;
      };

      /* La "liga": mientras se arrastra, estira sin transición desde el
         último punto real (anchor) hasta donde va el mouse/dedo ahora
         mismo — visualmente demuestra que SÍ se está moviendo. */
      var stretchBand = function (current) {
        if (!band) return;
        band.classList.remove("is-snapping");
        var a = pct(anchor);
        var c = pct(current);
        band.style.left = Math.min(a, c) + "%";
        band.style.width = Math.abs(c - a) + "%";
        band.classList.add("is-active");
      };

      /* Al soltar/confirmar: la liga se "suelta" con rebote hacia el punto
         real — colapsa a ancho 0 justo en ese punto y se desvanece. */
      var releaseBand = function (index) {
        if (!band) return;
        band.classList.add("is-snapping");
        band.style.left = pct(index) + "%";
        band.style.width = "0%";
        band.classList.remove("is-active");
        window.setTimeout(function () {
          band.classList.remove("is-snapping");
        }, 400);
      };

      var onInput = function () {
        var raw = parseInt(self.sommBudgetInput.value, 10);
        stretchBand(raw);
        self.renderSommBudgetLabels(rawPrice(raw));
      };

      /* Confirma el valor real (arrastre soltado o paso de teclado): quita
         is-dragging ANTES de fijar el valor snapeado, para que la
         transición del thumb (.dual-range--snap) sí anime este salto en
         particular, sin animar el arrastre en sí. */
      var commit = function () {
        self.sommBudgetInput.classList.remove("is-dragging");
        var value = toPrice(parseInt(self.sommBudgetInput.value, 10));
        anchor = points.indexOf(value) * SLOT;
        self.sommBudgetInput.value = anchor;
        self.state.sommBudgetTarget = value;
        releaseBand(anchor);
        self.renderSommBudgetLabels();
        self.renderRecap();
      };

      if (this.sommBudgetInput) {
        this.sommBudgetInput.addEventListener("input", onInput);
        this.sommBudgetInput.addEventListener("change", commit);
        /* Mientras se arrastra activamente, sin transición en el thumb (que
           no se sienta pegado al mouse) — commit() la quita justo antes de
           snapear, así el salto final SÍ se anima. */
        this.sommBudgetInput.addEventListener("pointerdown", function () {
          self.sommBudgetInput.classList.add("is-dragging");
        });
        /* Flechas/Page arriba-abajo saltan un punto real completo, en vez
           del step=1 nativo pensado solo para el arrastre con mouse. */
        this.sommBudgetInput.addEventListener("keydown", function (event) {
          var dir = {
            ArrowLeft: -1,
            ArrowDown: -1,
            ArrowRight: 1,
            ArrowUp: 1,
            PageDown: -1,
            PageUp: 1
          }[event.key];
          if (!dir) return;
          event.preventDefault();
          var next = clampNum(
            parseInt(self.sommBudgetInput.value, 10) + dir * SLOT,
            0,
            maxIndex,
            parseInt(self.sommBudgetInput.value, 10)
          );
          self.sommBudgetInput.value = next;
          self.sommBudgetInput.dispatchEvent(new Event("input", { bubbles: true }));
          self.sommBudgetInput.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      this.renderSommBudgetLabels();
    }

    /* Con override muestra el valor crudo mientras se arrastra (antes de
       snapear) — refuerza que el control sí responde al mouse/dedo. */
    renderSommBudgetLabels(override) {
      var el = this.root.querySelector("[data-winerd-somm-budget-val]");
      var text = money(override != null ? override : this.state.sommBudgetTarget);
      if (el) el.textContent = text;
      /* El value del <input> es un índice (0..400): el lector de pantalla
         debe anunciar el precio, no el índice. */
      if (this.sommBudgetInput) this.sommBudgetInput.setAttribute("aria-valuetext", text);
    }

    /* Expande/oculta la descripción dentro de la misma tarjeta — sin
       re-render, así no se pierde el estado del buscador/filtros. Se usa
       tanto en el catálogo del paso 3 como en el picker inline del paso 4
       (comparten wineCardMarkup). */
    bindDescToggle(container) {
      if (!container) return;
      container.addEventListener("click", function (event) {
        var btn = event.target.closest("[data-winerd-desc-toggle]");
        if (!btn) return;
        var card = btn.closest(".wine-card");
        var desc = card && card.querySelector(".wine-card__desc");
        if (!desc) return;
        var willOpen = desc.hidden;
        desc.hidden = !willOpen;
        btn.textContent = willOpen ? "Ocultar descripción" : "Ver descripción";
      });
    }

    loadCatalog(isRefresh) {
      var self = this;
      if (!this.grid) return;

      this.catalogLoaded = false;
      this.setCatalogStatus("loading", isRefresh ? "Actualizando catálogo…" : "Cargando catálogo…");
      this.grid.innerHTML =
        '<div class="catalog-loading"><span></span><span></span><span></span>' +
        "<p>Buscando etiquetas reales en Alcornoque</p></div>";

      var handle = this.root.dataset.winerdCollection || "vinos";
      var base = shopRoot();
      if (base.charAt(base.length - 1) !== "/") base += "/";

      var LIMIT = 250;
      /* winerd-subscriptions tiene ~2630 productos (~11 páginas de 250);
         15 deja margen para que la colección siga creciendo sin volver a
         truncar el catálogo silenciosamente (pasó con el límite viejo de 5:
         se veían 977 etiquetas de las 2630 reales). */
      var MAX_PAGES = 15;
      var all = [];

      function fetchPage(page) {
        var url =
          base +
          "collections/" +
          encodeURIComponent(handle) +
          "/products.json?limit=" +
          LIMIT +
          "&page=" +
          page;

        return fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
          .then(function (res) {
            if (!res.ok) throw new Error("HTTP " + res.status);
            return res.json();
          })
          .then(function (data) {
            var products = data && Array.isArray(data.products) ? data.products : [];
            all = all.concat(products);
            if (products.length === LIMIT && page < MAX_PAGES) return fetchPage(page + 1);
            return all;
          });
      }

      fetchPage(1)
        .then(function (products) {
          self.catalog = products.filter(productAvailable);
          self.catalogLoaded = true;
          self.setCatalogStatus(
            "live",
            "Catálogo en vivo · " +
              self.catalog.length +
              (self.catalog.length === 1 ? " etiqueta" : " etiquetas")
          );
          self.renderCatalog();
        })
        .catch(function (error) {
          if (window.console) console.warn("Winerd: no se pudo cargar el catálogo", error);
          self.catalog = [];
          self.catalogLoaded = true;
          self.setCatalogStatus("fallback", "No pudimos cargar el catálogo");
          self.renderCatalog();
        })
        .then(function () {
          if (self.pickerEl && !self.pickerEl.hidden) self.renderPicker();
        });
    }

    setCatalogStatus(kind, message) {
      var el = this.root.querySelector("[data-winerd-catalog-status]");
      if (!el) return;
      el.classList.toggle("is-live", kind === "live");
      el.classList.toggle("is-fallback", kind === "fallback");
      el.textContent = message;
    }

    sortComparator() {
      if (this.state.sortBy === "price_desc") {
        return function (a, b) {
          return productPrice(b) - productPrice(a);
        };
      }
      if (this.state.sortBy === "name_asc") {
        return function (a, b) {
          return a.title.localeCompare(b.title, "es");
        };
      }
      return function (a, b) {
        return productPrice(a) - productPrice(b);
      };
    }

    filteredCatalog() {
      var self = this;
      var tokens = this.state.search.toLowerCase().split(/\s+/).filter(Boolean);

      return this.catalog
        .filter(function (p) {
          return productMatchesType(p, self.state.catalogType);
        })
        .filter(function (p) {
          if (self.state.catalogCountry === "todos") return true;
          return productCountry(p) === self.state.catalogCountry;
        })
        .filter(function (p) {
          var price = productPrice(p);
          return price >= self.state.budgetMin && price <= self.state.budgetMax;
        })
        .filter(function (p) {
          if (!tokens.length) return true;
          var hay = productHaystack(p);
          return tokens.every(function (t) {
            return hay.indexOf(t) > -1;
          });
        })
        .sort(this.sortComparator());
    }

    renderCatalog() {
      if (!this.grid || !this.catalogLoaded) return;
      var self = this;

      var rangeEl = this.root.querySelector("[data-winerd-catalog-range]");
      var countEl = this.root.querySelector("[data-winerd-catalog-count]");

      var filtered = this.filteredCatalog();
      var visible = filtered.slice(0, 12);
      var max = this.selMax();
      var full = this.state.picks.length >= max;
      var picked = {};
      this.state.picks.forEach(function (p) {
        picked[p.handle] = true;
      });

      var tabLabel = TAB_LABEL[this.state.catalogType] || "Vinos";
      if (rangeEl) {
        rangeEl.textContent =
          (this.state.catalogType === "todos" ? "Vinos" : tabLabel + "s") +
          (this.state.catalogCountry === "todos" ? "" : " de " + this.state.catalogCountry) +
          " entre " +
          money(this.state.budgetMin) +
          " y " +
          money(this.state.budgetMax) +
          " por botella.";
      }
      if (countEl) {
        countEl.textContent =
          filtered.length + (filtered.length === 1 ? " etiqueta disponible" : " etiquetas disponibles");
      }

      if (!this.catalog.length) {
        this.grid.innerHTML = emptyState(
          "No pudimos cargar el catálogo.",
          'Toca "Actualizar catálogo" para reintentar, o continúa y deja que el sommelier arme tu caja.'
        );
        return;
      }
      if (!visible.length) {
        this.grid.innerHTML = emptyState(
          this.state.search
            ? "Sin resultados para “" + this.state.search + "”."
            : "No encontramos etiquetas en este rango.",
          "Amplía el presupuesto, limpia el buscador o prueba otra categoría."
        );
        return;
      }

      this.grid.innerHTML = visible
        .map(function (p) {
          var isPicked = !!picked[p.handle];
          return self.wineCardMarkup(p, {
            kicker: self.state.catalogType === "todos" ? "Selección Winerd" : tabLabel,
            added: isPicked,
            disabled: max === 0 || (full && !isPicked),
            actionAttr: 'data-winerd-add="' + esc(p.handle) + '"',
            actionLabel: isPicked ? "✓ Agregado" : "+ Agregar"
          });
        })
        .join("");
    }

    wineCardMarkup(p, opts) {
      opts = opts || {};
      var image = productImage(p);
      var desc = truncate(stripHtml(p.body_html), 200);
      var meta = [];
      var country = productCountry(p);
      if (country) meta.push(country);
      var wineType = productTagValue(p, "Tipo de Vino_");
      if (wineType) meta.push(wineType);

      var descBlock = "";
      if (desc || meta.length) {
        descBlock =
          '<button type="button" class="wine-card__desc-toggle" data-winerd-desc-toggle>Ver descripción</button>' +
          '<div class="wine-card__desc" hidden>' +
          (meta.length ? '<p class="wine-card__meta">' + esc(meta.join(" · ")) + "</p>" : "") +
          (desc ? "<p>" + esc(desc) + "</p>" : "") +
          "</div>";
      }

      return (
        '<article class="wine-card" data-handle="' + esc(p.handle) + '">' +
        (image
          ? '<img src="' + esc(image) + '" alt="' + esc(p.title) + '" loading="lazy">'
          : '<div class="wine-card__image-fallback">Alcornoque</div>') +
        '<div class="wine-card__copy">' +
        "<span>" + esc(opts.kicker || "Selección Winerd") + "</span>" +
        "<h4>" + esc(p.title) + "</h4>" +
        "<p>" + money(productPrice(p)) + "</p>" +
        descBlock +
        '<button type="button" class="catalog-add' +
        (opts.added ? " is-added" : "") +
        '" ' + (opts.actionAttr || "") +
        (opts.disabled ? " disabled" : "") +
        ">" +
        esc(opts.actionLabel || "+ Agregar") +
        "</button>" +
        "</div>" +
        "</article>"
      );
    }

    togglePick(handle, removeOnly) {
      var idx = this.state.picks.findIndex(function (p) {
        return p.handle === handle;
      });

      if (idx > -1) {
        this.state.picks.splice(idx, 1);
        this.toast("Etiqueta quitada");
      } else if (!removeOnly) {
        var max = this.selMax();
        if (max === 0) {
          this.toast("Este modo arma la caja con el sommelier");
          return;
        }
        if (this.state.picks.length >= max) {
          this.toast("Puedes elegir hasta " + max + (max === 1 ? " etiqueta" : " etiquetas"));
          return;
        }
        var product = this.catalog.find(function (p) {
          return p.handle === handle;
        });
        if (!product) return;
        this.state.picks.push(product);
        this.ensurePlanStatus(product);
        this.toast("Etiqueta agregada");
      }

      this.renderSlots();
      this.renderCatalog();
      this.renderProfile();
    }

    /* Consulta una sola vez (y cachea en el propio producto) si la etiqueta
       ya está enrolada en el selling plan group, para poder avisarle al
       cliente en el resumen ANTES de pagar — no solo detectarlo al vuelo en
       el checkout final. */
    ensurePlanStatus(product) {
      var self = this;
      if (product.hasPlan !== undefined) return;

      var base = shopRoot();
      if (base.charAt(base.length - 1) !== "/") base += "/";

      this.resolvePickLine(product, base).then(function (line) {
        product._resolvedLine = line;
        product.hasPlan = !!(line && line.selling_plan);
        self.renderRecap();
      });
    }

    renderSlots() {
      if (!this.slotsEl) return;

      var max = this.selMax();
      var somm = Math.max(0, this.qty - max);
      var picks = this.state.picks.slice(0, max);
      var html = "";

      for (var i = 0; i < max; i++) {
        var p = picks[i];
        if (p) {
          var image = productImage(p);
          html +=
            '<div class="selected-wine-slot">' +
            '<button class="selected-wine-remove" type="button" data-winerd-remove-pick="' +
            esc(p.handle) +
            '" aria-label="Quitar ' +
            esc(p.title) +
            '">×</button>' +
            (image ? '<img src="' + esc(image) + '" alt="' + esc(p.title) + '">' : "") +
            '<div class="selected-wine-slot__copy"><strong>' +
            esc(p.title) +
            "</strong><span>" +
            money(productPrice(p)) +
            "</span></div>" +
            "</div>";
        } else {
          html +=
            '<div class="selected-wine-slot is-empty"><span>+</span><small>Agrega una etiqueta</small></div>';
        }
      }
      for (var j = 0; j < somm; j++) {
        html +=
          '<div class="selected-wine-slot selected-wine-slot--somm">' +
          bottleIcon("sommelier", 22) +
          "<small>Lo elige tu sommelier</small></div>";
      }

      this.slotsEl.innerHTML = html;

      var countEl = this.root.querySelector("[data-winerd-slots-count]");
      if (countEl) countEl.textContent = this.state.picks.length + " de " + max;

      var note = this.root.querySelector("[data-winerd-somm-note]");
      if (note) note.hidden = max !== 0;
    }

    renderBudgetLabels() {
      var lo = this.root.querySelector("[data-winerd-budget-min-val]");
      var hi = this.root.querySelector("[data-winerd-budget-max-val]");
      if (lo) lo.textContent = money(this.state.budgetMin);
      if (hi) hi.textContent = money(this.state.budgetMax);
    }

    renderProfile() {
      var textEl = this.root.querySelector("[data-winerd-profile-text]");
      var namesEl = this.root.querySelector("[data-winerd-profile-names]");
      var max = this.selMax();
      var somm = Math.max(0, this.qty - max);

      if (textEl) {
        textEl.textContent =
          max +
          (max === 1 ? " tuya" : " tuyas") +
          " + " +
          somm +
          " del sommelier · " +
          this.state.occasion +
          " · " +
          money(this.state.budgetMin) +
          "–" +
          money(this.state.budgetMax) +
          " · " +
          this.state.frequency +
          " · " +
          this.qty +
          " botellas";
      }
      if (namesEl) {
        var names = this.state.picks.map(function (p) {
          return p.title;
        });
        namesEl.textContent = names.length
          ? names.join(" · ")
          : "Agrega vinos del catálogo para completar tu simulación.";
      }
    }

    refreshCatalogStep() {
      if (!this.grid && !this.slotsEl) return;
      var max = this.selMax();
      if (this.state.picks.length > max) {
        this.state.picks = this.state.picks.slice(0, max);
      }
      this.renderSlots();
      this.renderProfile();
      this.renderCatalog();
    }

    /* ---------- paso 4 · resumen editable + picker inline ---------- */

    bindRecapStep() {
      var self = this;
      this.recapEl = this.root.querySelector("[data-winerd-recap]");
      this.pickerEl = this.root.querySelector("[data-winerd-picker]");
      if (!this.recapEl) return;

      this.recapEl.addEventListener("click", function (event) {
        var btn = event.target.closest("[data-winerd-recap-action]");
        if (!btn) return;
        var row = btn.closest("[data-winerd-recap-row]");
        if (!row) return;
        var index = parseInt(row.dataset.winerdRecapRow, 10);
        var action = btn.dataset.winerdRecapAction;
        if (action === "remove") self.recapRemove(index);
        else if (action === "somm") self.recapToSomm(index);
        else if (action === "swap") self.openPicker(index);
      });

      if (!this.pickerEl) return;

      var search = this.pickerEl.querySelector("[data-winerd-picker-search]");
      if (search) {
        search.addEventListener("input", function () {
          self.state.picker.search = search.value.trim();
          self.renderPicker();
        });
      }

      toArray(this.pickerEl.querySelectorAll("[data-winerd-picker-type]")).forEach(function (tab) {
        tab.addEventListener("click", function () {
          self.state.picker.type = tab.dataset.winerdPickerType || "todos";
          toArray(self.pickerEl.querySelectorAll("[data-winerd-picker-type]")).forEach(function (other) {
            other.classList.toggle("is-active", other === tab);
          });
          self.renderPicker();
        });
      });

      var grid = this.pickerEl.querySelector("[data-winerd-picker-grid]");
      if (grid) {
        grid.addEventListener("click", function (event) {
          var pick = event.target.closest("[data-winerd-picker-pick]");
          if (!pick || pick.disabled) return;
          self.applyPicker(pick.dataset.winerdPickerPick);
        });
        this.bindDescToggle(grid);
      }

      var close = this.pickerEl.querySelector("[data-winerd-picker-close]");
      if (close) close.addEventListener("click", function () { self.closePicker(); });
    }

    recapSlots() {
      var slots = [];
      var picks = this.state.picks;
      var sommTotal = Math.max(0, this.qty - picks.length);
      var tinto = clampNum(this.state.sommTintoCount, 0, sommTotal, sommTotal);
      var sommSeen = 0;
      for (var i = 0; i < this.qty; i++) {
        if (i < picks.length) {
          slots.push({ type: "pick", product: picks[i] });
        } else {
          slots.push({ type: "somm", taste: sommSeen < tinto ? "tinto" : "blanco" });
          sommSeen++;
        }
      }
      return slots;
    }

    /* Devuelve el precio REAL que se cobrará — el slider del sommelier ya es
       un solo valor (no un rango), snapeado a uno de los 5 puntos winred al
       soltar, así que aquí no hay nada que promediar. */
    sommEstimate() {
      return this.state.sommBudgetTarget || 0;
    }

    syncQuantityGroup() {
      var group = this.root.querySelector('[data-winerd-group="quantity"]');
      if (!group) return;
      var qty = this.qty;
      toArray(group.querySelectorAll("[data-val]")).forEach(function (btn) {
        btn.classList.toggle("is-active", parseInt(btn.dataset.val, 10) === qty);
      });
    }

    recapRemove(index) {
      if (this.qty <= 1) {
        this.toast("Tu caja necesita al menos 1 botella");
        return;
      }
      if (index < this.state.picks.length) this.state.picks.splice(index, 1);
      this.qty -= 1;
      if (this.state.mixYou > this.qty) this.state.mixYou = this.qty;
      this.syncQuantityGroup();
      this.closePicker();
      this.selectMode(this.state.mode);
      this.renderRecap();
      this.toast("Botella quitada");
    }

    recapToSomm(index) {
      if (index >= this.state.picks.length) return;
      this.state.picks.splice(index, 1);
      this.closePicker();
      this.selectMode(this.state.mode);
      this.renderRecap();
      this.toast("Botella devuelta a tu sommelier");
    }

    openPicker(index) {
      if (!this.pickerEl || index >= this.state.picks.length) return;
      this.pickerIndex = index;
      this.state.picker.search = "";
      var search = this.pickerEl.querySelector("[data-winerd-picker-search]");
      if (search) search.value = "";
      var title = this.pickerEl.querySelector("[data-winerd-picker-title]");
      if (title) title.textContent = "Cambia: " + this.state.picks[index].title;
      this.pickerEl.hidden = false;
      this.renderPicker();
      try {
        this.pickerEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
        if (search) search.focus({ preventScroll: true });
      } catch (e) {}
    }

    closePicker() {
      if (this.pickerEl) this.pickerEl.hidden = true;
      this.pickerIndex = null;
    }

    pickerCandidates() {
      var self = this;
      var tokens = this.state.picker.search.toLowerCase().split(/\s+/).filter(Boolean);
      var chosen = {};
      this.state.picks.forEach(function (p, i) {
        if (i !== self.pickerIndex) chosen[p.handle] = true;
      });

      return this.catalog
        .filter(function (p) { return productMatchesType(p, self.state.picker.type); })
        .filter(function (p) {
          if (!tokens.length) return true;
          var hay = productHaystack(p);
          return tokens.every(function (t) { return hay.indexOf(t) > -1; });
        })
        .filter(function (p) { return !chosen[p.handle]; })
        .sort(function (a, b) { return productPrice(a) - productPrice(b); });
    }

    renderPicker() {
      if (!this.pickerEl) return;
      var self = this;
      var grid = this.pickerEl.querySelector("[data-winerd-picker-grid]");
      if (!grid) return;

      if (!this.catalogLoaded) {
        grid.innerHTML = emptyState("Cargando catálogo…", "Traemos las etiquetas reales de Alcornoque.");
        return;
      }
      if (!this.catalog.length) {
        grid.innerHTML = emptyState(
          "No pudimos cargar el catálogo.",
          'Vuelve al paso 3 y toca "Actualizar catálogo".'
        );
        return;
      }

      var candidates = this.pickerCandidates().slice(0, 12);
      if (!candidates.length) {
        grid.innerHTML = emptyState(
          this.state.picker.search
            ? "Sin resultados para “" + this.state.picker.search + "”."
            : "No hay más etiquetas en esta categoría.",
          "Prueba otra búsqueda o cambia de tipo de vino."
        );
        return;
      }

      grid.innerHTML = candidates
        .map(function (p) {
          return self.wineCardMarkup(p, {
            kicker: "Cambiar por",
            actionAttr: 'data-winerd-picker-pick="' + esc(p.handle) + '"',
            actionLabel: "Elegir esta"
          });
        })
        .join("");
    }

    applyPicker(handle) {
      var product = this.catalog.find(function (p) { return p.handle === handle; });
      if (!product || this.pickerIndex == null) return;
      this.state.picks[this.pickerIndex] = product;
      this.ensurePlanStatus(product);
      this.closePicker();
      this.selectMode(this.state.mode);
      this.renderRecap();
      this.toast("Botella actualizada");
    }

    renderRecap() {
      if (!this.recapEl) return;
      var self = this;
      var slots = this.recapSlots();
      var est = this.sommEstimate();

      this.recapEl.innerHTML = slots
        .map(function (slot, i) {
          if (slot.type === "somm") {
            var tasteLabel = slot.taste === "blanco" ? "Blanco" : "Tinto";
            return (
              '<div class="recap-row recap-row--somm" data-winerd-recap-row="' + i + '">' +
              '<div class="recap-row__media">' + bottleIcon(slot.taste, 28) + "</div>" +
              '<div class="recap-row__copy"><strong>Lo elige tu sommelier</strong>' +
              "<span>" + tasteLabel + " · " + (est ? money(est) : "Según tu perfil") + "</span></div>" +
              "</div>"
            );
          }
          var p = slot.product;
          var image = productImage(p);
          var planBadge =
            p.hasPlan === false
              ? '<small class="recap-row__plan-warning">⚠ Aún no repite sola en tu suscripción</small>'
              : "";
          return (
            '<div class="recap-row" data-winerd-recap-row="' + i + '">' +
            '<div class="recap-row__media">' +
            (image ? '<img src="' + esc(image) + '" alt="' + esc(p.title) + '">' : bottleIcon("tuya", 28)) +
            "</div>" +
            '<div class="recap-row__copy"><strong>' + esc(p.title) + "</strong>" +
            "<span>" + money(productPrice(p)) + "</span>" +
            planBadge +
            "</div>" +
            '<div class="recap-row__actions">' +
            '<button type="button" class="recap-action" data-winerd-recap-action="swap">Cambiar</button>' +
            '<button type="button" class="recap-action" data-winerd-recap-action="somm">Dejar al sommelier</button>' +
            '<button type="button" class="recap-action recap-action--danger" data-winerd-recap-action="remove">Quitar</button>' +
            "</div></div>"
          );
        })
        .join("");

      var picks = this.state.picks;
      var sommCount = Math.max(0, this.qty - picks.length);
      var subtotal = this.estimateTotal();

      var subEl = this.root.querySelector("[data-winerd-recap-subtotal]");
      if (subEl) subEl.textContent = money(subtotal);

      var unlinkedTitles = picks
        .slice(0, this.qty)
        .filter(function (p) {
          return p.hasPlan === false;
        })
        .map(function (p) {
          return p.title;
        });
      var planWarnEl = this.root.querySelector("[data-winerd-plan-warning]");
      if (planWarnEl) {
        planWarnEl.hidden = unlinkedTitles.length === 0;
        var planWarnText = planWarnEl.querySelector("[data-winerd-plan-warning-text]");
        if (planWarnText && unlinkedTitles.length) {
          planWarnText.textContent =
            "Todavía no están en tu plan de suscripción: " +
            unlinkedTitles.join(", ") +
            ". Se cobran en este envío tal como las elegiste; si quieres que se repitan en tus próximos envíos, dínoslo al confirmar y las agregamos.";
        }
      }

      var sommLabel = sommCount + " del sommelier";
      if (sommCount > 2) {
        var sommTinto = clampNum(this.state.sommTintoCount, 0, sommCount, sommCount);
        sommLabel += " (" + sommTinto + " tintas, " + (sommCount - sommTinto) + " blancas)";
      }

      var metaEl = this.root.querySelector("[data-winerd-recap-meta]");
      if (metaEl) {
        metaEl.textContent =
          this.qty +
          (this.qty === 1 ? " botella · " : " botellas · ") +
          picks.length +
          " tuyas · " +
          sommLabel +
          " · " +
          this.state.frequency;
      }

      var ship = this.root.querySelector("[data-winerd-ship]");
      var fill = this.root.querySelector("[data-winerd-ship-fill]");
      var shipNote = this.root.querySelector("[data-winerd-ship-note]");
      if (this.freeShip > 0) {
        if (ship) ship.hidden = false;
        var pct = Math.max(0, Math.min(100, Math.round((subtotal / this.freeShip) * 100)));
        if (fill) fill.style.width = pct + "%";
        if (shipNote) {
          shipNote.textContent =
            subtotal >= this.freeShip
              ? "¡Tu caja alcanza el envío gratis a México!"
              : "Te faltan " + money(this.freeShip - subtotal) + " para el envío gratis.";
        }
      } else if (ship) {
        ship.hidden = true;
      }

      if (this.pickerEl && !this.pickerEl.hidden) this.renderPicker();
    }

    /* ---------- paso 5 · renovación + checkout ---------- */

    estimateTotal() {
      var picks = this.state.picks.slice(0, this.qty);
      var sommCount = Math.max(0, this.qty - picks.length);
      var est = this.sommEstimate();
      var subtotal = 0;
      picks.forEach(function (p) {
        subtotal += productPrice(p);
      });
      return subtotal + sommCount * est;
    }

    freqMonths() {
      return FREQ_MONTHS[this.state.frequency] || 2;
    }

    freqPlanId() {
      return WINRED.plans[this.freqMonths()] || WINRED.plans[2];
    }

    nearestPricePoint(value) {
      var v = Number(value) || 0;
      return WINRED.points.reduce(function (best, p) {
        return Math.abs(p - v) < Math.abs(best - v) ? p : best;
      }, WINRED.points[0]);
    }

    bindRenewalStep() {
      var self = this;

      var checkoutBtn = this.root.querySelector("[data-winerd-checkout]");
      if (checkoutBtn) {
        checkoutBtn.addEventListener("click", function () {
          self.checkout();
        });
      }

      toArray(this.root.querySelectorAll("[data-winerd-edit-box]")).forEach(function (btn) {
        btn.addEventListener("click", function () {
          self.goPanel(4);
        });
      });
    }

    renewalDates() {
      var months = this.freqMonths();
      var ship = new Date();
      ship.setMonth(ship.getMonth() + months);
      var notice = new Date(ship.getTime());
      notice.setDate(notice.getDate() - 7);
      return { ship: ship, notice: notice };
    }

    renderRenewal() {
      var self = this;
      var picks = this.state.picks.slice(0, this.qty);
      var sommCount = Math.max(0, this.qty - picks.length);
      var total = this.estimateTotal();
      var dates = this.renewalDates();

      var fmtLong = function (d) {
        try {
          return new Intl.DateTimeFormat("es-MX", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric"
          }).format(d);
        } catch (e) {
          return d.toLocaleDateString();
        }
      };
      var fmtShort = function (d) {
        try {
          return new Intl.DateTimeFormat("es-MX", { day: "numeric", month: "long" }).format(d);
        } catch (e) {
          return d.toLocaleDateString();
        }
      };

      var set = function (attr, value) {
        var el = self.root.querySelector("[" + attr + "]");
        if (el) el.textContent = value;
      };

      set("data-winerd-nd-date", fmtLong(dates.ship));
      set("data-winerd-nd-mode", MODE_LABEL[this.state.mode]);
      set(
        "data-winerd-nd-content",
        this.qty +
          (this.qty === 1 ? " botella · " : " botellas · ") +
          picks.length +
          " tuyas + " +
          sommCount +
          " del sommelier"
      );
      set("data-winerd-nd-total", money(total));
      set("data-winerd-nd-notice", fmtShort(dates.notice));
      set("data-winerd-nd-charge", fmtShort(dates.ship));
      set("data-winerd-nd-charge-total", money(total));

      this.setCheckoutError("");
    }

    setCheckoutError(message) {
      var el = this.root.querySelector("[data-winerd-checkout-error]");
      if (!el) return;
      el.hidden = !message;
      el.textContent = message || "";
    }

    grapeLists() {
      var s = this.state;
      var likes = [];
      var open = [];
      var no = [];
      Object.keys(s.grapes).forEach(function (name) {
        if (s.grapes[name] === "like") likes.push(name);
        else if (s.grapes[name] === "open") open.push(name);
        else if (s.grapes[name] === "no") no.push(name);
      });
      return { likes: likes, open: open, no: no };
    }

    /* Atributos estructurados del pedido (no solo texto libre en la nota):
       pensados para que un Shopify Flow ("Order created" → "Update customer
       metafield") pueda copiar el perfil del cliente a su ficha sin tener
       que parsear la nota. Esta app no puede escribir metacampos del
       cliente directamente desde el storefront (requiere Admin API), así
       que el Flow es el puente. */
    buildProfileAttributes() {
      var s = this.state;
      var g = this.grapeLists();
      var picks = s.picks.slice(0, this.qty);
      var sommCount = Math.max(0, this.qty - picks.length);
      var sommTinto = clampNum(s.sommTintoCount, 0, sommCount, sommCount);

      var attrs = {
        "Winerd modo": MODE_LABEL[s.mode],
        "Winerd frecuencia": s.frequency,
        "Winerd ocasión": s.occasion,
        "Winerd nivel de aventura": s.adventure,
        "Winerd nivel de experiencia": s.level,
        "Winerd cepas que le gustan": g.likes.join(", ") || "—",
        "Winerd cepas abiertas a probar": g.open.join(", ") || "—",
        "Winerd cepas que no le gustan": g.no.join(", ") || "—",
        "Winerd presupuesto etiquetas": money(s.budgetMin) + "-" + money(s.budgetMax),
        "Winerd presupuesto sommelier": money(s.sommBudgetTarget),
        "Winerd reparto sommelier":
          sommCount > 0 ? sommTinto + " tintas, " + (sommCount - sommTinto) + " blancas" : "—",
        "Winerd sobre mí": s.aboutMe.trim() || "—"
      };
      if (this.unlinkedPicks && this.unlinkedPicks.length) {
        attrs["Winerd sin plan de suscripción"] = this.unlinkedPicks.join(", ");
      }
      return attrs;
    }

    buildNote() {
      var s = this.state;
      var picks = s.picks.slice(0, this.qty).map(function (p) {
        return p.title;
      });
      var sommCount = Math.max(0, this.qty - picks.length);
      var g = this.grapeLists();
      var likes = g.likes;
      var open = g.open;
      var no = g.no;

      var sommTasteLine;
      if (sommCount <= 0) {
        sommTasteLine = "Tipo base del sommelier: — (sin botellas para el sommelier)";
      } else {
        var sommTinto = clampNum(s.sommTintoCount, 0, sommCount, sommCount);
        sommTasteLine =
          "Tipo base del sommelier: " + sommTinto + " tintas, " + (sommCount - sommTinto) + " blancas";
      }

      return [
        "— Configuración Winerd —",
        "Modo: " + MODE_LABEL[s.mode],
        "Caja: " +
          this.qty +
          " botellas · " +
          picks.length +
          " elegidas por el cliente · " +
          sommCount +
          " del sommelier",
        sommTasteLine,
        "Nivel de experiencia: " + s.level,
        "Nivel de aventura: " + s.adventure,
        "Ocasión: " + s.occasion,
        "Frecuencia: " + s.frequency,
        "Presupuesto de tus etiquetas: " + money(s.budgetMin) + "–" + money(s.budgetMax),
        "Presupuesto del sommelier: " + money(s.sommBudgetTarget),
        "Me gusta: " + (likes.join(", ") || "—"),
        "Abierto a: " + (open.join(", ") || "—"),
        "No me gusta: " + (no.join(", ") || "—"),
        "Etiquetas elegidas: " + (picks.join(" · ") || "—"),
        "Sobre mí: " + (s.aboutMe.trim() || "—")
      ]
        .concat(
          this.unlinkedPicks && this.unlinkedPicks.length
            ? [
                "⚠ SIN PLAN DE SUSCRIPCIÓN (se cobran hoy pero NO se repiten solas — " +
                  "agrégalas al selling plan group y avisa al cliente del cambio): " +
                  this.unlinkedPicks.join(" · ")
              ]
            : []
        )
        .join("\n");
    }

    winredLine(quantity, plan, taste) {
      if (quantity <= 0) return null;
      var point = this.nearestPricePoint(this.sommEstimate() || this.state.sommBudgetTarget || 935);
      var map = taste === "blanco" ? WINRED.blanco : WINRED.tinto;
      var id = map[String(point)];
      if (!id) return null;
      var line = { id: id, quantity: quantity };
      if (plan) line.selling_plan = plan;
      return line;
    }

    /* Reparte `quantity` botellas del sommelier entre tinto/blanco según el
       reparto elegido en data-winerd-somm-split (siempre activo). */
    winredLines(quantity, plan) {
      if (quantity <= 0) return [];

      var tinto = clampNum(this.state.sommTintoCount, 0, quantity, quantity);
      var blanco = quantity - tinto;
      var lines = [];
      var tintoLine = this.winredLine(tinto, plan, "tinto");
      var blancoLine = this.winredLine(blanco, plan, "blanco");
      if (tintoLine) lines.push(tintoLine);
      if (blancoLine) lines.push(blancoLine);
      return lines;
    }

    resolvePickLine(product, base) {
      if (product._resolvedLine) return Promise.resolve(product._resolvedLine);
      var self = this;

      var fallback = function () {
        var variants = Array.isArray(product.variants) ? product.variants : [];
        var v =
          variants.filter(function (x) {
            return x && x.id && x.available !== false;
          })[0] ||
          variants.filter(function (x) {
            return x && x.id;
          })[0];
        return v ? { id: v.id, quantity: 1 } : null;
      };

      return fetch(base + "products/" + encodeURIComponent(product.handle) + ".js", {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })
        .then(function (res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.json();
        })
        .then(function (detail) {
          var variants = Array.isArray(detail.variants) ? detail.variants : [];
          var variant =
            variants.filter(function (v) {
              return v && v.id && v.available !== false;
            })[0] ||
            variants.filter(function (v) {
              return v && v.id;
            })[0];
          if (!variant) return fallback();

          var line = { id: variant.id, quantity: 1 };
          var allocs = Array.isArray(variant.selling_plan_allocations)
            ? variant.selling_plan_allocations
            : [];
          /* Migración #116: el catálogo general ya tiene los 3 planes reales
             (1/2/3 meses) — hay que tomar el que coincide con la frecuencia
             que eligió el cliente, no cualquiera. Antes se tomaba siempre
             allocs[0] (el primero), así que un pick específico se quedaba
             pegado en "cada 1 mes" sin importar lo que el cliente eligiera;
             solo las botellas winred (con el ID fijo por WINRED.plans)
             cambiaban de verdad. selling_plan_id llega como número desde
             products/<handle>.js — se compara como string para no fallar
             por tipo contra el ID de WINRED.plans (que sí es string). */
          var wantedPlan = String(self.freqPlanId());
          var match =
            allocs.filter(function (a) {
              return a && a.selling_plan_id && String(a.selling_plan_id) === wantedPlan;
            })[0] || allocs[0];
          if (match && match.selling_plan_id) {
            line.selling_plan = match.selling_plan_id;
          }
          return line;
        })
        .catch(function () {
          return fallback();
        });
    }

    buildCheckoutItems(base) {
      var self = this;
      var plan = this.freqPlanId();
      var picks = this.state.picks.slice(0, this.qty);
      var sommCount = Math.max(0, this.qty - picks.length);

      /* Etiquetas del cliente que no tenían selling_plan (aún no enrolada en
         el SellingPlanGroup): se cobran hoy como compra única, pero Shopify
         Subscriptions NO las mete al contrato recurrente — se caen de la
         caja desde el segundo envío si nadie las enrola después. Se listan
         aquí para poder marcarlas en la nota/atributos del pedido. */
      this.unlinkedPicks = [];

      if (this.state.mode === "somm" || !picks.length) {
        return Promise.resolve(this.winredLines(this.qty, plan));
      }

      return Promise.all(
        picks.map(function (p) {
          return self.resolvePickLine(p, base);
        })
      ).then(function (lines) {
        var items = [];
        lines.forEach(function (line, i) {
          if (!line) return;
          items.push(line);
          if (!line.selling_plan) self.unlinkedPicks.push(picks[i].title);
        });
        if (sommCount > 0) {
          items = items.concat(self.winredLines(sommCount, plan));
        }
        return items;
      });
    }

    checkout() {
      var self = this;
      var btn = this.root.querySelector("[data-winerd-checkout]");
      var base = shopRoot();
      if (base.charAt(base.length - 1) !== "/") base += "/";

      this.setCheckoutError("");
      if (btn) {
        btn.disabled = true;
        btn.dataset.label = btn.dataset.label || btn.textContent;
        btn.textContent = "Preparando checkout…";
      }

      var restore = function () {
        if (!btn) return;
        btn.disabled = false;
        btn.textContent = btn.dataset.label || "Confirmar y pagar";
      };

      this.buildCheckoutItems(base)
        .then(function (items) {
          if (!items.length) {
            throw new Error(
              "No pudimos armar tu caja para el checkout. Revisa tu selección o inténtalo de nuevo."
            );
          }
          return fetch(base + "cart/clear.js", {
            method: "POST",
            headers: { Accept: "application/json" }
          }).then(function () {
            return fetch(base + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ items: items })
            });
          });
        })
        .then(function (res) {
          if (!res.ok) {
            return res
              .json()
              .catch(function () {
                return {};
              })
              .then(function (err) {
                throw new Error(
                  err && err.description
                    ? err.description
                    : "No se pudo agregar la caja al carrito."
                );
              });
          }
          var attributes = self.buildProfileAttributes();
          return fetch(base + "cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              note: self.buildNote(),
              attributes: attributes
            })
          });
        })
        .then(function () {
          window.location.href = base + "checkout";
        })
        .catch(function (error) {
          if (window.console) console.warn("Winerd checkout:", error);
          self.setCheckoutError(
            error && error.message
              ? error.message
              : "No pudimos preparar el checkout. Intenta de nuevo."
          );
          restore();
        });
    }

    toast(message) {
      var el = this.root.querySelector("[data-winerd-toast]");
      if (!el) {
        el = document.createElement("div");
        el.className = "simulation-toast";
        el.setAttribute("data-winerd-toast", "");
        this.root.appendChild(el);
      }
      el.textContent = message;
      el.classList.add("show");
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(function () {
        el.classList.remove("show");
      }, 2200);
    }
  }

  function boot() {
    toArray(document.querySelectorAll("[data-winerd-configurator]")).forEach(function (el) {
      if (el.__winerdConfigurator) return;
      el.__winerdConfigurator = new WinerdConfigurator(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
